export const GRID_AREA_TITLE = 'title';
export const GRID_AREA_SUBTITLE = 'subtitle';
export const GRID_AREA_ACTION = 'action';
